export const cutText = (text: string, length = 20) => (text.length > length ? `${text.slice(0, length)}...` : text);
